import { GameObjectReference, GameState } from "@shared/types";
import { Page } from "../enums/Page";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { css, html, htmlArray } from "../helpers/webComponents";
import { InventoryService } from "../services/InventoryService";
import { GameObject } from "../../../api/src/game-base/gameObjects/GameObject";

/** CSS affecting the {@link NotFoundComponent} */
const styles: string = css`

:host {
        font-family: "Onesize";
        width: 100%;
        max-width: 1024px;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto calc(35vh + 10px) minmax(calc(35vh + 10px), 1fr) auto;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
    }
    
    img {
        width: 50%;
        size: 50%;
    }

    .closebutton{
        position: static;
    
    }

    .inventorybutton{
        position: relative;
        left:970px;
        top: 42px;
        cursor:pointer;
    }
    .test {
        color: grey;
         text-align: center;
    }


    .inventory-container{
        border-radius: 10px 10px 0 0;
        background-color: #52478b;
        border: 1px solid #332c57;
        margin: 10px;
        height: auto;
        padding: 5px;
    }


    td {
        padding: 10px;
        padding-right: 35px;
        width: 200px;
        text-align: center;
        border-bottom: 1px solid #ddd;
    }

     #descriptionrow {
        width:  400px;
    }
`;

export class InventoryComponent extends HTMLElement {
    private _inventoryService: InventoryService = new InventoryService();
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    /** Current active game object buttons */
    private _selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        void this.refreshGameState();
    }

    /**
         * Refresh the current game state
         */
    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();

        await this.updateGameState(state);
    }

    private async getItems(): Promise<GameObject[]> {
        const items: GameObject[] = await this._inventoryService.listItems();
        console.log(items);
        return items;
    }

    /**
         * Update the canvas to the provided game state
         *
         * @param state Game state to update the canvas to
         */
    private async updateGameState(state: GameState): Promise <void> {
        // Handle switching pages, if requested.
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);

            return;
        }

        this._selectedGameObjectButtons.clear();

        // Refresh the web component
        await this.render();
    }

    /**
         * Render the contents of this page
         */
    private async render(): Promise <void> {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
                    <style>
                        ${styles}
                    </style>

        ${this.renderExitButtonInventory()}
        ${await this.renderInventory()}


            `;
        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }
        this.shadowRoot.append(...elements);
    }

    private async renderInventory(): Promise<HTMLElement> {
        const element: HTMLDivElement = document.createElement("div");

        element.innerHTML = `
        <div class="inventorywindow">
            <div class="inventory-container">
                <table class="inventory-table">
                    <thead> 
                   
                        <tr>

                        </tr>
                    </thead>
                    <tbody id="inventory-body">
                    </tbody>
                </table>
            </div>
        </div>
    `;

        const tableBody: Element | null = element.querySelector("#inventory-body");
        if (!tableBody) {
            console.error("Table body not found!");
            return element;
        }

        try {
            const items: GameObject[] = await this.getItems();

            // Clear the loading message
            tableBody.innerHTML = "Inventory";

            // Generate table rows dynamically
            items.forEach(item => {
                const row: HTMLTableRowElement = document.createElement("tr");
                row.innerHTML = `
                <td><img src=${item["_imagePath"]} width="50"></td>
                <td>${item["_alias"]}</td>
                <td id = "descriptionrow">${item["_description"]}</td>
            `;
                tableBody.appendChild(row);
            });
        }
        catch (error) {
            console.error(" Error fetching inventory:", error);
        }

        return element;
    }

    private renderExitButtonInventory(): HTMLElement {
        const exitelement: HTMLElement = html`
<div>
    <div class= "closebutton">
                <button class="inventorybutton" id="invbutton">
                    X
                    </button>
            </div>
    </div>
`;
        exitelement.addEventListener("click", () => this._gameEventService.switchPage(Page.Canvas));
        return exitelement;
    }
}
